import * as React from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button, ButtonProps } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

interface SplitButtonProps {
  // Main button props
  onMainClick?: () => void
  mainButtonText: string
  mainButtonIcon?: React.ReactNode
  mainButtonProps?: Omit<ButtonProps, "onClick" | "children">
  
  // Dropdown props
  dropdownItems: Array<{
    key: string
    label: string
    onClick: () => void
    icon?: React.ReactNode
    disabled?: boolean
  }>
  
  // Overall props
  className?: string
  disabled?: boolean
}

export function SplitButton({
  onMainClick,
  mainButtonText,
  mainButtonIcon,
  mainButtonProps = {},
  dropdownItems,
  className,
  disabled = false,
}: SplitButtonProps) {
  return (
    <div className={cn("flex", className)}>
      {/* Main Button */}
      <Button
        onClick={onMainClick}
        disabled={disabled}
        className="rounded-r-none border-r-0"
        {...mainButtonProps}
      >
        {mainButtonIcon && (
          <span className="mr-2 flex items-center">
            {mainButtonIcon}
          </span>
        )}
        {mainButtonText}
      </Button>
      
      {/* Dropdown Button */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant={mainButtonProps.variant || "default"}
            size={mainButtonProps.size || "default"}
            disabled={disabled}
            className="rounded-l-none px-2"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {dropdownItems.map((item) => (
            <DropdownMenuItem
              key={item.key}
              onClick={item.onClick}
              disabled={item.disabled}
              className="flex items-center gap-2"
            >
              {item.icon && item.icon}
              {item.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}